module.exports = __webpack_public_path__ + "static/media/snapchat-social-social-media-icon-svgrepo-com.76319993.svg";